export default __webpack_public_path__ + "images/5875acae67ad83bd9b8a66b44cf5c8d1.svg";